import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-3xl text-sm font-bold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary:
          "bg-soft-green text-white shadow-lg hover:bg-light-mint hover:-translate-y-1 hover:shadow-float",
        destructive:
          "bg-red-600 text-white shadow-lg hover:bg-red-700 hover:-translate-y-1 hover:shadow-float",
        outline:
          "border border-light-gray bg-white text-charcoal shadow-lg hover:bg-off-white hover:-translate-y-1 hover:shadow-float dark:bg-dark-surface dark:border-dark-border dark:text-white dark:hover:bg-gray-800",
        secondary:
          "bg-white border border-light-gray text-charcoal shadow-lg hover:bg-off-white hover:-translate-y-1 hover:shadow-float dark:bg-dark-surface dark:border-dark-border dark:text-white dark:hover:bg-gray-800",
        ghost: "text-muted-gray hover:text-charcoal hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800",
        link: "text-soft-green underline-offset-4 hover:underline",
      },
      size: {
        default: "h-12 px-6 py-3",
        sm: "h-9 px-4 text-xs",
        lg: "h-14 px-8 text-base",
        xl: "h-16 px-10 text-xl rounded-[2rem]",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} 
    />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
